// @flow
import type { ExpressParams, FetchCurrentUserResponse } from '@rover/react-lib/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import { camelize } from '@rover/utilities/object-utilities';
import { getAxiosInstance } from '@rover/utilities/axiosUtils';
import userFactory from '@rover/react-lib/factories/userFactory';
import { UTM_PARAMS } from '@rover/utilities/utm';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const CURRENT_USER_URL: string = fullApiUrl('frontend/current-user/');

export const get = async (expressParams: ?ExpressParams): Promise<FetchCurrentUserResponse> => {
  const ai = getAxiosInstance(expressParams);

  try {
    const { data } = await ai.get(CURRENT_USER_URL);
    const camelData = camelize(data, true, UTM_PARAMS);
    camelData.currentUser = camelData.currentUser || userFactory();
    camelData.realUser = camelData.realUser || userFactory();
    return camelData;
  } catch (e) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching the current user.');
  }
};

export default { get };



// WEBPACK FOOTER //
// ../react-lib/src/apis/currentUser.api.js